import Api from "@/config/Api";

export default {
  getCategories() {
    return Api().get("/categories", {});
  }
};
